import { parseCsvList } from "./videoMetrics"

const chipTones = {
  indigo: "bg-indigo-50 border-indigo-200 text-indigo-700",
  amber: "bg-amber-50 border-amber-400 text-amber-800",
}

/*
  One of the detail pane's soft blocks: a label over a wrap of chips. Serves both
  pathologies and indications, which differ only in colour — the API returns both
  as a comma-separated string.
*/
const TagChipGroup = ({
  label,
  values,
  tone = "indigo",
  emptyLabel = "N/A",
}) => {
  const entries = parseCsvList(values)

  return (
    <div className="bg-gray-50 rounded-xl p-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 mb-2">
        {label}
      </p>
      {entries.length > 0 ? (
        <div className="flex flex-wrap gap-1.5">
          {entries.map((entry, index) => (
            <span
              key={`${entry}-${index}`}
              className={`px-2 py-0.5 text-xs rounded-full border ${chipTones[tone]}`}
            >
              {entry}
            </span>
          ))}
        </div>
      ) : (
        <span className="text-xs text-gray-400 italic">{emptyLabel}</span>
      )}
    </div>
  )
}

export default TagChipGroup
